<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="room">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            入住评估分类
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
                    <div style="float:right">
                        <!-- <el-input  placeholder="请输入评估分类名称" v-model="nameSearch" clearable style="margin:0 10px;width:200px"></el-input> -->
                        <el-select v-model="statusSearch" placeholder="选择评估分类状态" style="margin:0 10px;" >
                            <el-option
                                    v-for="item in statusValue"
                                    :key="item.val"
                                    :label="item.name"
                                    :value="item.val">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="name" label="评估分类名称"></el-table-column>
                        
                        <el-table-column prop="sumGroup" label="评估分类组数"></el-table-column>

                        <el-table-column prop="sumScore" label="评估分类总分"></el-table-column>

                        <el-table-column prop="calculationType" :formatter="getType" label="是否为分数"></el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <el-dialog title='评估分类添加' :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
            <el-form>
                <el-form-item label="评估分类名称" required style="width:100%">
                    <el-input v-model="nameAdd" placeholder="请输入评估分类名称"></el-input>
                </el-form-item>
                <el-form-item label="计算类型是否为分数" required style="width:100%">
                    <el-select v-model="calculationTypeAdd" placeholder="请选择计算类型是否为分数" style="width:100%" >
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchDialog=false">取 消</el-button>
                <el-button type="primary"  @click="addSub">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog title='评估分类修改' :visible.sync="batchDialogEdit" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
            <el-form>
                <el-form-item label="评估分类名称" required style="width:100%">
                    <el-input v-model="nameEdit" placeholder="请输入评估分类名称"></el-input>
                </el-form-item>
                <el-form-item label="计算类型是否为分数" required style="width:100%">
                    <el-select v-model="calculationTypeEdit" placeholder="请选择计算类型是否为分数" style="width:100%" >
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评估分类状态" required style="width:100%">
                    <el-select v-model="status" placeholder="选择评估分类状态" style="width:100%">
                        <el-option label="正常" :value="1"></el-option>
                        <el-option label="禁用" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchDialogEdit=false">取 消</el-button>
                <el-button type="primary"  @click="editSub">提交</el-button>
            </div>
        </el-dialog>
        <!-- <Add ref="myAdd" v-show="showModalAdd"  v-bind:roomTypeList="roomTypeList" v-bind:buildingCodeValue="buildingCodeValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:roomTypeList="roomTypeList"  v-bind:buildingCodeValue="buildingCodeValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    // import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                disabledAdd:true,
                menuButtonList:null,
                disabledEdit:true,
                tableData:null,
                status:-1,
                statusSearch:-1,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                batchDialog:false,
                batchDialogEdit:false,
                nameAdd:'',
                calculationTypeAdd:'',
                calculationTypeEdit:'',
                nameEdit:'',
                nameSearch:'',
                infoTitleCode:'',
                selectInfo:'',
                statusValue:[{
                    val:-1,
                    name:'全部'
                },{
                    val:1,
                    name:'正常'
                },{
                    val:2,
                    name:'禁用'
                }],
            }
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            handleEdit() {
                this.checkinAssessClassCode=this.selectInfo.checkinAssessClassCode;
                this.nameEdit=this.selectInfo.name;
                this.status=this.selectInfo.status;
                this.calculationTypeEdit=this.selectInfo.calculationType;
                this.batchDialogEdit=true
            },
            toggleModalAdd:function(){
                this.nameAdd='';
                this.calculationTypeAdd='';
                this.batchDialog =true;
            },
            getType(a,b,data){
                if(data==1){
                    return '是'
                }
                return '否'
            },
            addSub(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CheckinAssessClass/Add",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.nameAdd,
                        calculationType:this.calculationTypeAdd
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.batchDialog=false
                        this.getList();
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            editSub(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CheckinAssessClass/Edit",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        checkinAssessClassCode:this.checkinAssessClassCode,
                        name:this.nameEdit,
                        status:this.status,
                        calculationType:this.calculationTypeEdit
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.batchDialogEdit=false
                        this.getList();
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CheckinAssessClass/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        // name:this.nameSearch,
                        status:this.statusSearch,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize
                    }
                }).then( (response)=> {
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                const statusValue=this.statusValue
                for(var i in statusValue){
                    if(statusValue[i].val==row.status){
                        return statusValue[i].name
                    }
                }   
            },
             rowClick(row){
                this.selectInfo=row
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit=false
                }
                
            }
        }
    }
</script>

<style lang='scss' scoped>
    .room /deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
</style>
